import { render } from "./RedCatIcon.svg?vue&type=template&id=23ad119e"
const script = {}
script.render = render

export default script